import React from "react";
import { Bar } from "react-chartjs-2";
import "./Graphs.css";
import { Chart } from "chart.js";

const customLabelOnHover = {
  id: "customLabelOnHover",
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.save();
    ctx.font = "bold 8px Arial";
    ctx.fillStyle = `${getComputedStyle(
      document.documentElement
    ).getPropertyValue("--tertiaryColor6")}`;
    ctx.textAlign = "center";

    if (chart.config.type !== "bar") {
      return;
    }

    if (chart.tooltip?.dataPoints?.length > 0) {
      const activeElement = chart.tooltip.dataPoints[0];
      if (activeElement) {
        const { x, y } = activeElement.element.getProps(["x", "y"]);
        const value = activeElement.raw;
        if (value > 0) {
          ctx.fillText(`${activeElement.dataset.label} - ${value}`, x, y - 6);
        }
      }
    }

    ctx.restore();
  }
};

Chart.register(customLabelOnHover);

export default function BarChart(props) {
  const customOptions = {
    layout: {
      padding: {
        top: 10
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
      customLabelOnHover
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false
        },
        ticks: {
          display: true,
          color: `${getComputedStyle(document.documentElement).getPropertyValue(
            "--tertiaryColor6"
          )}`
        }
      },
      y: {
        stacked: false,
        grid: {
          display: false
        },
        ticks: {
          display: false,
          color: `${getComputedStyle(document.documentElement).getPropertyValue(
            "--tertiaryColor6"
          )}`
        }
      }
    },
    interaction: {
      intersect: false,
      mode: "nearest"
    },
    responsive: true,
    maintainAspectRatio: false,
    onHover: (event, chartElements) => {
      const chart = event.chart;

      if (chartElements.length > 0) {
        const element = chartElements[0];
        chart.tooltip.setActiveElements(
          [{ datasetIndex: element.datasetIndex, index: element.index }],
          { x: event.x, y: event.y }
        );
      } else {
        chart.tooltip.setActiveElements([], {});
      }
      chart.draw();
    }
  };

  return (
    <div className="inherit-parent-height inherit-parent-width flex-align-items-center flex-justify-content-center flex-direction-column position-relative">
      <div className="height-90-percentage inherit-parent-width display-flex flex-align-items-center">
        <Bar
          data={props.data}
          options={customOptions}
          style={{
            minWidth: "100%",
            minHeight: "100%"
          }}
          className="inherit-parent-width height-width"
        />
      </div>
    </div>
  );
}
